import { Typography } from 'components'
import React from 'react'
import styled from 'styled-components'

export const WidgetTitle: React.FC<{
  children?: string | string[]
}> = ({ children }) => {
  return (
    <TitleStyled
      fontSize="text_xs"
      className="jetbrains-mono"
      fontWeight="medium"
      color="grey500"
      noWrap
    >
      {children}
    </TitleStyled>
  )
}

const TitleStyled = styled(Typography)`
  flex-shrink: 0;
`
